import React from 'react';
import DeployStatusUpdateView from './DeployStatusUpdateView';
import DeployStatusUpdateLogic from './DeployStatusUpdateLogic';

const DeployStatusUpdatePage = () => {
  const {
    fileId,
    loading,
    deploymentStatus,
    cardTemplates,
    selectedCardId,
    selectedStatus,
    appName,
    storeUrl,
    saving,
    error,
    success,
    sendEmail,
    userName,
    userEmail,
    getStatusLabel,
    handleSubmit,
    handleStoreUrlChange,
    handleCardSelect,
    handleStatusSelect,
    handleSendEmailChange,
    handleBackClick,
    reloadData
  } = DeployStatusUpdateLogic();

  return (
    <DeployStatusUpdateView
      fileId={fileId}
      loading={loading}
      deploymentStatus={deploymentStatus}
      cardTemplates={cardTemplates}
      selectedCardId={selectedCardId}
      selectedStatus={selectedStatus}
      appName={appName}
      storeUrl={storeUrl}
      saving={saving}
      error={error}
      success={success}
      sendEmail={sendEmail}
      userName={userName}
      userEmail={userEmail}
      getStatusLabel={getStatusLabel}
      handleSubmit={handleSubmit}
      handleStoreUrlChange={handleStoreUrlChange}
      handleCardSelect={handleCardSelect}
      handleStatusSelect={handleStatusSelect}
      handleSendEmailChange={handleSendEmailChange}
      handleBackClick={handleBackClick}
      reloadData={reloadData}
    />
  );
};

export default DeployStatusUpdatePage; 